module.exports = __webpack_public_path__ + "img/icon_heart_6.dab82a50.svg";